import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { InvoicesDataProvider } from '../../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { UtilsServiceProvider } from '../../../../../../../shared/services/utils/utils-service';

@Component({
	selector: 'shootproof-delete-gallery-modal',
	template: require('./shootProof-delete-gallery.modal.html'),
	styles: [require('./shootProof-delete-gallery.modal.scss')]
})
export class ShootProofDeleteGalleryModal {
	@Input('deleteGalleryId') deleteGalleryId: number;
	@Input('actions')
	set actions(value) {
		this.checkAvailableActions(value);
		this._actions = value;
	}

	get actions() {
		return this._actions;
	}
	@Output('updateGalleries')
	updateGalleries: EventEmitter<any> = new EventEmitter<any>();
	buttonsDisable = false;
	deleteGalleryFromSNSpinner = false;
	_actions;
	showDeleteFromSNBtn = true;
	showDeleteFromSPBtn = true;

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService,
		private invoiceDataService: InvoicesDataProvider,
		private utilService: UtilsServiceProvider
	) {}

	dismiss() {
		$('#deleteShootProofGalleryModal').modal('hide');
		this.removeSpinners();
	}

	deleteGalleryFromSN() {
		this.deleteGalleryFromSNSpinner = true;
		this.deleteGallery();
	}

	openDeleteConfirmationModal() {
		this.utilService.showNextModal(
			'#deleteShootProofGalleryModal',
			'#deleteConfirmationModal',
			null
		);
	}

	private checkAvailableActions(actions) {
		if (actions && actions !== null) {
			this.showDeleteFromSNBtn =
				actions.hasOwnProperty('DELETE_FROM_SN') &&
				actions.DELETE_FROM_SN.state === 'active';
			this.showDeleteFromSPBtn =
				actions.hasOwnProperty('DELETE_FROM_SP') &&
				actions.DELETE_FROM_SP.state === 'active';
		} else {
			this.showDeleteFromSNBtn = false;
			this.showDeleteFromSPBtn = false;
		}
	}

	private deleteGallery() {
		this.buttonsDisable = true;
		this.shootProofDataService
			.removeJobGalleryV1(this.deleteGalleryId, false)
			.finally(() => this.removeSpinners())
			.subscribe(
				() => this.successDeleteGallery(),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private removeSpinners() {
		this.buttonsDisable = false;
		this.deleteGalleryFromSNSpinner = false;
	}

	private successDeleteGallery() {
		this.updateGalleriesEvent();
		this.messageService.showToaster('s_5', 'shootProof');
		this.dismiss();
	}

	private updateGalleriesEvent() {
		this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
		this.updateGalleries.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/integrations/shootProof/modals/shootProof-delete-gallery-modal/shootProof-delete-gallery.modal.ts